/**
 * Sort groups by user-selected field; fallback to impressions when field is text-only.
 * For Media Devoted | Created By Ciro Autiero
 */

import { getVoluumValueForDisplay } from './voluum';

const TEXT_FIELDS = new Set([
  'dropList', 'list', 'gateway', 'source', 'text', 'path', 'lander', 'offer',
]);

export function sortGroupsByField<T extends { key: string; label: string; totals: Record<string, number> }>(
  items: T[],
  sort: { field: string; dir: 'asc' | 'desc' } | null,
): T[] {
  const mult = sort?.dir === 'asc' ? 1 : -1;
  const field = sort?.field;

  if (!field || TEXT_FIELDS.has(field)) {
    return [...items].sort((a, b) => {
      const impA = a.totals.impressions ?? a.totals.visits ?? a.totals.sends ?? 0;
      const impB = b.totals.impressions ?? b.totals.visits ?? b.totals.sends ?? 0;
      return (impA - impB) * mult;
    });
  }

  return [...items].sort((a, b) => {
    const aVal = getVoluumValueForDisplay(a.totals, field);
    const bVal = getVoluumValueForDisplay(b.totals, field);
    const aNum = typeof aVal === 'number' ? aVal : null;
    const bNum = typeof bVal === 'number' ? bVal : null;

    if (aNum != null && bNum != null) return (aNum - bNum) * mult;
    if (aNum != null) return -1;
    if (bNum != null) return 1;
    const impA = a.totals.impressions ?? a.totals.visits ?? a.totals.sends ?? 0;
    const impB = b.totals.impressions ?? b.totals.visits ?? b.totals.sends ?? 0;
    return (impB - impA) * mult;
  });
}
